import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DataResponse } from '../../../../core/models/data-response';
import { ConfigService } from '../../../../core/services/config/config.service';
import { UtilityService } from '../../../../core/services/utility/utility.service';
import { PatientAllergy } from '../../models/patient-allergy';

@Injectable({
  providedIn: 'root',
})
export class PatientAllergiesService {
  private utilityService = inject(UtilityService);
  private configService = inject(ConfigService);
  private config = this.configService.config;

  patientAllergiesEndpoint = `${this.config.patientApiUrl}/v1/PatientPortal/PatientAllergies`;

  postPatientAllergies(
    patientId: number,
    pageNumber: number | undefined,
    pageSize: number | undefined
  ): Observable<DataResponse<PatientAllergy[]>> {
    const searchParams = {
      pageNumber,
      pageSize,
    };
    return this.utilityService.postRequest<DataResponse<PatientAllergy[]>>(
      `${this.patientAllergiesEndpoint}?patientId=${patientId}`,
      searchParams,
      // Both reads opt out of the global error page: AllergiesComponent renders app-error-state
      // with a retry instead, so a failed load no longer tears down the page.
      { rawResponse: true, skipGlobalError: true, applyDefaultTimeout: true }
    );
  }

  getAllPatientAllergiesByPatientId(patientId: number): Observable<PatientAllergy[]> {
    const url = `${this.patientAllergiesEndpoint}?patientId=${patientId}`;
    return this.utilityService.getRequest<PatientAllergy[]>(url, { skipGlobalError: true });
  }

  postPrintEvent(patientId: number, ids: number[]): Observable<void> {
    const url = `${this.patientAllergiesEndpoint}/PrintEvent?patientId=${patientId}`;
    return this.utilityService.postRequest<void>(url, { ids }, { skipGlobalError: true });
  }
}
